module.exports = __webpack_public_path__ + "img/barDentro.cbdf78d7.jpg";